import React from "react";

export const PrevArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={className}
      style={{ ...style, display: "block", background: "transparent" }}
      onClick={onClick}
      type="button"
    >
        <svg width="25" height="44" viewBox="0 0 25 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 42L3 22L23 2" stroke="black" stroke-width="3"/>
        </svg>
    </button>
  );
};

export const NextArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={className}
      style={{ ...style, display: "block", background: "transparent" }}
      onClick={onClick}
      type="button"
    >
        <svg width="25" height="44" viewBox="0 0 25 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 42L22 22L2 2" stroke="black" stroke-width="3"/>
        </svg>
    </button>
  );
};